import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./StudentLevelSectionUIHelpers";

const StudentLevelSectionUIContext = createContext();

export function useStudentLevelSectionUIContext() {
  return useContext(StudentLevelSectionUIContext);
}

export const StudentLevelSectionUIConsumer = StudentLevelSectionUIContext.Consumer;

export function StudentLevelSectionUIProvider({ studentLevelSectionUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openStudentAssignmentPage: studentLevelSectionUIEvents.openStudentAssignmentPage
  };

  return (
    <StudentLevelSectionUIContext.Provider value={value}>
      {children}
    </StudentLevelSectionUIContext.Provider>
  );
}